// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PoundCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PoundCircleOutlined = function PoundCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleOutlinedSvg
  }));
};

PoundCircleOutlined.displayName = 'PoundCircleOutlined';
export default React.forwardRef(PoundCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PoundCircleOutlined.js
// module id = 3836
// module chunks = 0